'use client';

import { useEffect } from 'react';

// The root <html> is rendered by the root layout and can't see the locale route
// segment, so it always ships as en/ltr. This component runs in the [...slug]
// layout (which knows the language) and syncs documentElement.lang/dir on the
// client. Works on Cloudflare Pages without middleware.
export default function HtmlLangSync({ lang }) {
  useEffect(() => {
    const dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
    document.documentElement.dir = dir;
  }, [lang]);

  return null;
}
